import { BFFAgent } from 'BFFAgent';
import * as moment from 'moment';
import { put, call } from 'redux-saga/effects'
import { STOCK_TAKING_CAR_MANAGMENT_SAVE_FAILURE, STOCK_TAKING_CAR_MANAGMENT_SAVE_SUCCESS } from "../constants";

export function* saveTakingCarManagmentSaga({data: takingCarManagmentData}){
    try {

        const dataSended = {
            id: takingCarManagmentData.tcm_id,
            requestsId: takingCarManagmentData.requests_id,
            valorCompra: takingCarManagmentData.tcm_buy_value,
            valorEmpresa: takingCarManagmentData.tcm_bussines_value,
            valorCarmuv: takingCarManagmentData.tcm_carmuv_value,
            destino: takingCarManagmentData.tcm_destination,
            estadoVenta: takingCarManagmentData.tcm_status_name,
            fechaCambioEstado: moment(takingCarManagmentData.tcm_date_state_change).format('YYYY-MM-DD H:mm:ss'),
            canalOrigen: takingCarManagmentData.tcm_source_channel,
            urlFoto: takingCarManagmentData.tcm_url_picture
        }

        const takingCarManagmentSaved = yield call( BFFAgent.Stock.TakingCarManagement.saveTakingCarManagment, dataSended)

        if(takingCarManagmentSaved){
            yield put({
                type: STOCK_TAKING_CAR_MANAGMENT_SAVE_SUCCESS,
                data: takingCarManagmentSaved
            })
        }
        
    } catch (error) {
        yield put({
            type: STOCK_TAKING_CAR_MANAGMENT_SAVE_FAILURE,
            data: {error}
        })
    }
}